import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Modal} from "react-bootstrap";
import BackEnd from "../backend/BackEnd";
import {errorToast, successToast} from "../utils/toasts";
import {UserContext} from "../auth/Auth";

class RegisterSupplierModal extends Component {
    static propTypes = {
        show: PropTypes.bool.isRequired,
        onHide: PropTypes.func.isRequired
    };
    static defaultProps = {};
    state = {
        email: '',
        isEmailInvalid: false
    };

    render() {
        return (
            <Modal {...this.props} bsSize="large">
                <Modal.Header>
                    Регистрация поставщика
                </Modal.Header>
                <Modal.Body>
                    <form className={this.state.isLoading ? 'form-loading' : ''}>
                        <p>
                            Работа в системе в качестве поставщика позволяет получать рассылки с заказами на покупку/продажу паллет и{' '}
                            давать свою цену по каждому заказу. Для того, чтобы получить статус поставщика в системе, пожалуйста, укажите{' '}
                            свой email.
                        </p>
                        <div className="row">
                            <div className="col-sm-12 col-md-12 col-lg-9 col-xl-8 col-xxl-6">
                                <fieldset className={`form-group ${this.state.isEmailInvalid ? 'has-error' : ''}`}>
                                    <label className="control-label required"
                                           htmlFor="email">EMail</label>
                                    <input type="email" className="form-control"
                                           name="email" id="email"
                                           value={this.state.email}
                                           onChange={event => this.setState({email: event.target.value})}/>
                                    {
                                        this.state.isEmailInvalid &&
                                        <small class="form-message">EMail имеет неверный формат</small>
                                    }
                                </fieldset>
                            </div>
                        </div>
                    </form>
                </Modal.Body>
                <Modal.Footer>
                    <button type="button" className="btn btn-primary"
                            onClick={() => this.registerSupplier()}>
                        Продолжить
                    </button>
                    <button type="button" className="btn btn-default"
                            onClick={() => this.props.onHide()}>
                        Отменить
                    </button>
                </Modal.Footer>
            </Modal>
        );
    }

    async registerSupplier() {
        const {onHide} = this.props;
        const {email} = this.state;
        const emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

        if (!emailRegex.test(email.toLowerCase())) {
            this.setState({isEmailInvalid: true});
            return;
        }
        else {
            this.setState({isEmailInvalid: false});
        }

        const createCrmLead2 = new BackEnd.CrmLeads.CreateCrmLead2(this);
        let result = await createCrmLead2.call();
        if (!result.success)
            return;

        const register = new BackEnd.SupplierRegistration.Register(this);
        result =  await register.call({dto: {email}});
        if (result.success) {
            UserContext.set(result.data);
            successToast('Вы успешно зарегистрировались в качестве поставщика.');
            window.location.reload();
        }
        else if (result.errorMessage) {
            errorToast(result.errorMessage);
        }

        onHide();
    }
}

export default RegisterSupplierModal;


// WEBPACK FOOTER //
// ./src/components/RegisterSupplierModal.js